import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageSceneOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-4">
      <GenerateImageOptionButton title="Garden" value="in a garden" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Beach" value="on the beach" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Office" value="in an office" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Bedroom"
        value="in a bedroom"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton
        title="Classroom"
        value="in a classroom"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Gym" value="in a gym" onClick={props.updatePrompt} />
      <GenerateImageOptionButton
        title="Restaurant"
        value="in a restaurant"
        onClick={props.updatePrompt}
      />
      <GenerateImageOptionButton title="Taxi" value="in a taxi" onClick={props.updatePrompt} />
      <GenerateImageOptionButton title="Forest" value="in a forest" onClick={props.updatePrompt} />
    </div>
  )
}

export default GenerateImageSceneOptions
